import React, {useState} from 'react';
import {Container, Collapse, Row, Col, Tabs, Tab, Table, Card, Form} from 'react-bootstrap';
import '../layout/main.scss';
import '../home/home.scss';
import './collection.scss';
import troycard from '../../images/TROYGRUN.jpg';
import sog_col from "../../images/sog_collection.png";


function Collection() {
    const [open, setOpen] = useState(false);

    return (
        <div className="App">
            <div className="collection">
                <Container>
                    <h3>Collection</h3>
                    <div className="collection-info">
                        <img src={sog_col} alt="Spells of Genesis"/>
                        <h3>Spells of Genesis</h3>
                        <p>The 1st blockchain-based mobile game ever made, Spells of Genesis combines TCG functionalities with the point-and-shoot aspects of arcade games. Players have to collect and combine cards to create the strongest deck in order to fight their enemies.</p>
                    </div>
                    <div className="collection-content">
                        <Tabs defaultActiveKey="Orbs" id="orbs-tab" className="mb-3">
                            <Tab eventKey="Orbs" title="Orbs">
                                <div className="collection_filters">Find asset
                                    <Form className="d-flex">
                                        <input type="search" id="searchasset" name="searchasset" placeholder="Search asset" size={20}/>
                                    </Form>
                                </div>
                                <div className="mn-blocks home-asset">
                                    <Row xs={1} sm={2} md={3} lg={4} className="g-4">
                                        {Array.from({ length: 8 }).map((_, idx) => (
                                            <Col>
                                                <Card className="cards cardAsset">
                                                    <Card.Img variant="top" src={troycard} />
                                                    <Card.Body>
                                                        <h5>TROYGRUN</h5>
                                                        <h6>Spells of genesis</h6>
                                                        <hr/>
                                                        <div className="clearfix">
                                                            <span style={{float: 'left'}}>Issuance date:</span>
                                                            <span style={{float: 'right'}}>06.03.2016</span>
                                                        </div>
                                                        <div className="clearfix">
                                                            <span style={{float: 'left'}}>Nb issued:</span>
                                                            <span style={{float: 'right'}}>300</span>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        ))}
                                    </Row>
                                </div>
                            </Tab>
                            <Tab eventKey="Transactions" title="Transactions">
                                <Table striped bordered hover>
                                    <thead>
                                    <tr>
                                        <th>#</th>
                                        <th>Asset/Contract</th>
                                        <th>Image</th>
                                        <th>Time</th>
                                        <th>Blockchain</th>
                                        <th>Collection</th>
                                        <th>From</th>
                                        <th>To</th>
                                        <th>Qty</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>1</td>
                                        <td>TROYGRUN</td>
                                        <td>(image)</td>
                                        <td>Timestamp</td>
                                        <td>Counterparty</td>
                                        <td>Spells of Genesis</td>
                                        <td>1jnewfr...sd46z</td>
                                        <td>1lfn84r...48fnh</td>
                                        <td>1</td>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>TROYGRUN</td>
                                        <td>(image)</td>
                                        <td>Timestamp</td>
                                        <td>Counterparty</td>
                                        <td>Spells of Genesis</td>
                                        <td>1jnewfr...sd46z</td>
                                        <td>1lfn84r...48fnh</td>
                                        <td>1</td>
                                    </tr>
                                    <tr>
                                        <td>1</td>
                                        <td>TROYGRUN</td>
                                        <td>(image)</td>
                                        <td>Timestamp</td>
                                        <td>Counterparty</td>
                                        <td>Spells of Genesis</td>
                                        <td>1jnewfr...sd46z</td>
                                        <td>1lfn84r...48fnh</td>
                                        <td>1</td>
                                    </tr>
                                    </tbody>
                                </Table>
                            </Tab>
                        </Tabs>
                    </div>

                </Container>
            </div>
        </div>
    );
}

export default Collection;
